import classNames from 'classnames'

import type { TStretchedDeviceType } from '~/types/device-type'

import { DEVICE_TYPE } from '.'
import AppStoreLogo from '~/assets/app-store-logo.png'
import GooglePlayStoreLogo from '~/assets/google-play-store-logo.png'
import { getCountries } from '~/utils/countries'

export const platformOptions = [
  { label: 'All', value: '' },
  {
    image: <img src={GooglePlayStoreLogo} />,
    label: 'Android',
    value: 'android',
  },
  {
    image: <img src={AppStoreLogo} />,
    label: 'iOS',
    value: 'ios',
  },
]

export const countryWithFlagOptions = getCountries().map((option) => ({
  ...option,
  icon: <span className={classNames('option-flag-icon fi', { [`fi-${option.value.toLowerCase()}`]: true })} />,
}))

const STRETCHED_DEVICE_TYPE: Record<string, TStretchedDeviceType> = {
  ...DEVICE_TYPE,
  ALL: 'all',
}

const allDeviceTypes: Record<TStretchedDeviceType, IOption> = {
  all: { label: 'All', value: STRETCHED_DEVICE_TYPE.ALL },
  android: { label: 'Android', value: STRETCHED_DEVICE_TYPE.ANDROID },
  ios: { label: 'iOS', value: STRETCHED_DEVICE_TYPE.IOS },
  web: { label: 'Web', value: STRETCHED_DEVICE_TYPE.WEB },
}

export const getDeviceTypeOptions = (deviceTypes: TStretchedDeviceType[]): IOption[] => {
  return deviceTypes.map((key) => allDeviceTypes[key as keyof typeof allDeviceTypes]).filter(Boolean)
}
